import { ReactComponent as IconWarning } from 'styles/images/icon_warning.svg';

export const STEP = {
  PATIENT_INFO: 0,
  CCRC_INFO: 1,
  SIGN_PAGE: 2,
  GUARDIAN_INFO: 3,
};
export const NOTIFICATION_CONTENTS = {
  TITLE: (
    <>
      입원동의서 작성 전
      <br />
      안내 사항을 확인해 주세요
    </>
  ),
  DESC: (
    <>
      원활한 진행을 위해 아래 안내 사항을 확인하신 후 입원동의서 작성을 이어서 진행할 수 있어요.
      <br />
      궁금한 점이 있다면 병원으로 문의해 주세요.
    </>
  ),
  ICON: <IconWarning />,
};
